import React from 'react';
import PropTypes from 'prop-types';

import {Box, Skeleton} from 'views/components';

const UserSkeleton = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1.5}
      sx={{
        px: '12px',
        py: '8px',
      }}
    >
      {/* Circular avatar skeleton */}
      <Skeleton variant="circular" width={40} height={40} />

      {/* Name text skeleton */}
      <Skeleton variant="text" width="60%" height={28} />
    </Box>
  );
};

UserSkeleton.propTypes = {
  weekDays: PropTypes.arrayOf(PropTypes.object),
};

export default UserSkeleton;
